import { Field } from "formik";

export default function Select({
    label,
    field,
    children,
    required = false,
    useFormik = true,
    className = "",
    ...props
}) {
    const baseClasses = "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none";
    const selectClasses = `${baseClasses} ${className}`;
    
    return (
        <div>
            {label && (
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {label}
                    {required && <span className="text-red-500 mr-1">*</span>}
                </label>
            )}
            <div className="relative">
                {useFormik ? (
                    <Field as="select" {...field} {...props} className={selectClasses}>
                        {children}
                    </Field>
                ) : (
                    <select {...props} className={selectClasses}>
                        {children}
                    </select>
                )}
                <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>
        </div>
    )
}